module.exports = __webpack_public_path__ + "img/arh_3.1b909d4f.jpg";